// A dynamic resource (a runtime-supplied `openModal`/frame resource, not declared in `manifest.yml`)
// may select a multi-entry bundle's entry via a `<resourceKey>/<entryKey>` form. The entry maps to
// `${entryKey}.html` (the UIKit2 build output). Segments are limited to these characters.
const RESOURCE_SEGMENT_PATTERN = /^[a-zA-Z0-9_-]+$/;

export const resolveDynamicResource = (
	rawResource: string | undefined,
): { resolvedResourceEntry: string | undefined; resource: string | undefined } => {
	// No (or empty) resource — e.g. a UIKit extension with no resource — has nothing to parse, so
	// return it as-is with no entry rather than calling `.split` on an undefined value.
	if (!rawResource) {
		return { resource: rawResource, resolvedResourceEntry: undefined };
	}
	const [resource, entryKey, ...rest] = rawResource.split('/');
	// Only a single `<resourceKey>/<entryKey>` split with safe segments selects an entry. Anything
	// else (no slash, multiple slashes, or an unsafe entry) yields no entry — which also clears any
	// entry inherited from a parent extension so it can't bleed. The resource is always the first
	// segment, so e.g. "a/b/c" resolves to resource "a" with no entry.
	if (
		rest.length === 0 &&
		RESOURCE_SEGMENT_PATTERN.test(resource) &&
		RESOURCE_SEGMENT_PATTERN.test(entryKey ?? '')
	) {
		return { resource, resolvedResourceEntry: `${entryKey}.html` };
	}
	return { resource, resolvedResourceEntry: undefined };
};
